import React from 'react'
import { useSelector } from 'react-redux'

import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  // eslint-disable-next-line
} from '@vis.gl/react-google-maps/dist/index.umd.js'
import missingMarkersData from './missingLots.json'
import { CustomIcon } from '../../../../../apps/AppComponents/IconPicker/IconPicker'
import { setMarkerInfo } from '../../redux/myMapsSlice'
import { isWithinRadius } from '../../helpers/helpers'

const MissingLotMarker = ({ latitude, longitude, dispatch }) => {
  const [missingMarkers, updateMissingMarkers] = React.useState([])
  React.useEffect(() => {
    updateMissingMarkers(missingMarkersData)
    const nearestParking = isWithinRadius(
      latitude,
      longitude,
      missingMarkersData,
    )
    updateMissingMarkers(nearestParking)
  }, [latitude, longitude])
  return (
    <div>
      {missingMarkers?.map((missingMarker) => (
        <MissingLotAdvancedMarker
          key={missingMarker['MAP ID']}
          missingMarker={missingMarker}
          dispatch={dispatch}
        />
      ))}
    </div>
  )
}

const MissingLotAdvancedMarker = ({ missingMarker, dispatch }) => {
  const [setActive, updateSetActive] = React.useState(false)
  const { markerInfo } = useSelector((s) => s.maps)
  const handleUpdateShowCard = () => {
    dispatch(setMarkerInfo(missingMarker))
  }
  React.useEffect(() => {
    if (markerInfo && markerInfo['Map ID'] === missingMarker['Map ID']) {
      updateSetActive(!setActive)
    } else {
      updateSetActive(false)
    }
  }, [markerInfo])
  return (
    <AdvancedMarker
      key={missingMarker['MAP ID']}
      position={{ lat: missingMarker?.Lat, lng: missingMarker.Long }}
      title={missingMarker['Property Name']}
      clickable
      onClick={handleUpdateShowCard}
      anchorPoint={AdvancedMarkerAnchorPoint.TOP}
      style={{ zIndex: 9999 }}
    >
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <CustomIcon
          imgSrc={
            setActive
              ? './assets/images/svgs/parking-lot-icon-active.svg'
              : './assets/images/svgs/parking-lot-icon.svg'
          }
          size={setActive ? 35 : 25}
        />
      </div>
    </AdvancedMarker>
  )
}

export default MissingLotMarker
